export const templateTypes = {
    'ERTL': 1,
    'PMA': 2
}

export const templateTypesDict = {
    1: 'ERTL',
    2: 'PMA'
}

export const templateStatus = {
    1: 'Inactive',
    2: 'Active'
}

export const templatePlaceholders = {
    ERTL: {
        p1_date: 'Date',
        ertl_number: 'ERTL Number',
        agent_names: 'Associate Names',
        agent_name: 'Associate Name',
        property_address1: 'Property Address 1',
        property_address2: 'Property Address 2',
        property_city: 'Property City',
        property_zipcode: 'Property Zipcode',
        first_name:  'First Name',
        last_name: 'Last Name',
        owner_initials: 'Owner Initials',
        broker_initials: 'Broker Initials'
    },
    PMA: {
        owner_initials: 'Owner Initials',
        broker_initials: 'Broker Initials',
        owner_signature: 'Owner Signature',
        broker_signature: 'Broker Signature'
    }
}

export const templateBlockTypes = {
    0: 'Default', // Editor
    // 1: 'Inline', // Span
    // 2: 'Signature', // 
    3: 'Logo', // Left
    4: 'Centered Logo',
    // 5: 'Variable',
    // 6: 'Initial',
    7: 'Page Break',
    8: '2 Column Table'
}

export const defaultTemplateEntry = {
    json_data: [],
    title: ''
}

export const logoHTML = `<img src="https://illicre.com/wp-content/uploads/2020/04/admin-ajax-3-1-1.png" style="width:80px;" />`;

export const pageBreakCSS = `
    <style>
    .page-break {
        page-break-before: always;
        break-before: page;
    }
    </style>
`;

export const pageBreakHTML = `
    <div class="page-break" style="page-break-before:always;break-before:page"></div>
`;

export const ownerBrokerHTML = `

`;

export const twoColumnTable = `
    <center>
        <table class="the-table">
            <tbody>
                <tr>
                    <td>
                        {{ column_one }}
                    </td>
                    <td style="padding-left:20px">
                        {{ column_two }}
                    </td>
                </tr>
            </tbody>
        </table>
    </center>
`;